//
// Events helper.
function AdsNinjaEventHelper(){

    this.__arePassiveEventListenersSupported = null;
}

//
// Generic throttle for callbacks.
AdsNinjaEventHelper.prototype.throttle = function(callback, interval){

    var enableCall = true;

    return function(){

        var values = Array.prototype.slice.call(arguments, 0);

        if(!enableCall){

            return;
        }

        enableCall = false;

        callback.apply(null, values);

        setTimeout(function(){

            enableCall = true;
        }, interval);
    }
}

//
// Determines if passive event listeners are supported.
AdsNinjaEventHelper.prototype.arePassiveEventListenersSupported = function(){

    if(null !== this.__arePassiveEventListenersSupported){

        return this.__arePassiveEventListenersSupported;
    }

    /**
     * From MDN, used to verify if browser has passive capability.
     *
     * @see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
     */
    var passiveSupported = false;

    try {

        var options = {
            // This function will be called when the browser attempts to access the passive property.
            get passive(){

                passiveSupported = true;

                return false;
            }
        };

        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
    }
    catch(error){

        passiveSupported = false;
    }

    this.__arePassiveEventListenersSupported = passiveSupported;

    return this.__arePassiveEventListenersSupported;
}

window.AdsNinjaEventHelper = AdsNinjaEventHelper;